<ion-header *ngIf="!device.isMobile()">
  <ion-toolbar>
    <ng-container *ngIf="leaderboard.puzzleHasLeaderboardEntry$ | async">
      <ion-title>{{ "PUZZLE.leaderboard_info_modal.finished_with_leaderboard.title" | translate }}</ion-title>
    </ng-container>
    <ng-container *ngIf="(leaderboard.puzzleIsFinished$ | async) && !(leaderboard.puzzleHasLeaderboardEntry$ | async)">
      <ion-title>{{ "PUZZLE.leaderboard_info_modal.finished_without_leaderboard.title" | translate }}</ion-title>
    </ng-container>
    <ng-container *ngIf="!(leaderboard.puzzleIsFinished$ | async) && (leaderboard.withinLeaderboardSubmissionTime$ | async)">
      <ion-title *ngIf="leaderboard.strictRulesActive$ | async">{{ "PUZZLE.leaderboard_info_modal.ongoing_rules_strict.title" | translate }}</ion-title>
      <ion-title *ngIf="!(leaderboard.strictRulesActive$ | async)">{{ "PUZZLE.leaderboard_info_modal.ongoing_rules_relaxed.title" | translate }}</ion-title>
    </ng-container>
    <ng-container *ngIf="!(leaderboard.puzzleIsFinished$ | async) && !(leaderboard.withinLeaderboardSubmissionTime$ | async)">
      <ion-title>{{ "PUZZLE.leaderboard_info_modal.ongoing_outside_submission_time.title" | translate }}</ion-title>
    </ng-container>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-grid>
    <ion-row >
      <ion-col class="leaderboard-col-padding">
        <p *ngIf="leaderboard.puzzleHasLeaderboardEntry$ | async">{{ "PUZZLE.leaderboard_info_modal.finished_with_leaderboard.message" | translate : { submissionEndLocalized: (leaderboard.leaderboardSubmissionEndLocalizedStr$ | async), submissionStartLocalized: (leaderboard.leaderboardSubmissionStartLocalizedStr$ | async)} }}</p>
        <p *ngIf="(leaderboard.puzzleIsFinished$ | async) && !(leaderboard.puzzleHasLeaderboardEntry$ | async)">{{ "PUZZLE.leaderboard_info_modal.finished_without_leaderboard.message" | translate : { submissionEndLocalized: (leaderboard.leaderboardSubmissionEndLocalizedStr$ | async), submissionStartLocalized: (leaderboard.leaderboardSubmissionStartLocalizedStr$ | async)} }}</p>
        <ng-container *ngIf="!(leaderboard.puzzleIsFinished$ | async) && !(leaderboard.submissionPolicyViolation$ | async) && (leaderboard.withinLeaderboardSubmissionTime$ | async)">
          <ng-container *ngIf="!(leaderboard.strictRulesActive$ | async)">
            <p>{{ "PUZZLE.leaderboard_info_modal.ongoing_rules_relaxed.message" | translate :  { submissionEndLocalized: (leaderboard.leaderboardSubmissionEndLocalizedStr$ | async)} }}</p>
            <ul>
              <li *ngFor="let helper of leaderboard.leaderboardAssociation?.helpersUsed; index as i">
                {{ "PUZZLE.leaderboard_info_modal.ongoing_rules_relaxed.used_helper_" + helper | translate }}
              </li>
            </ul>
          </ng-container>
          <p *ngIf="leaderboard.strictRulesActive$ | async">{{ "PUZZLE.leaderboard_info_modal.ongoing_rules_strict.message" | translate : { submissionEndLocalized: (leaderboard.leaderboardSubmissionEndLocalizedStr$ | async), submissionStartLocalized: (leaderboard.leaderboardSubmissionStartLocalizedStr$ | async)} }}</p>
        </ng-container>
          <p *ngIf="!(leaderboard.puzzleHasLeaderboardEntry$ | async) && (leaderboard.submissionPolicyViolation$ | async) && (leaderboard.withinLeaderboardSubmissionTime$ | async)">{{ "PUZZLE.leaderboard_info_modal.submission_policy_violation." + (leaderboard.submissionPolicyViolation$ | async) | translate }}</p>
        <p *ngIf="!(leaderboard.puzzleIsFinished$ | async) && !(leaderboard.withinLeaderboardSubmissionTime$ | async)">{{ "PUZZLE.leaderboard_info_modal.ongoing_outside_submission_time.message" | translate : { submissionEndLocalized: (leaderboard.leaderboardSubmissionEndLocalizedStr$ | async), submissionStartLocalized: (leaderboard.leaderboardSubmissionStartLocalizedStr$ | async)} }}</p>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col class="leaderboard-col-padding">
        <lib-app-leaderboard-tabs *ngIf="leaderboard.leaderboardAssociation?.submittedEntryUUID !== undefined" lib-app-leaderboard-tabs withMessage="true"></lib-app-leaderboard-tabs>
        <lib-app-leaderboard-tabs *ngIf="leaderboard.leaderboardAssociation?.submittedEntryUUID === undefined" withMessage="true"></lib-app-leaderboard-tabs>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
<ion-footer>
  <div class="puzzle-modal-buttons">
    <ion-button color="primary" (click)="closeModal()" fill="solid">
      <span>{{"PUZZLE.leaderboard_info_modal.back_to_game" | translate }}</span>
      <ion-icon slot="start" name="backspace-sharp"></ion-icon>
    </ion-button>

  </div>
</ion-footer>


